module.exports = __webpack_public_path__ + "media/images/faq-165c643c166ecb137f1cfe3012d50e54.png";